// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6Aocd","col":"styles_col__2Za3s"};